import { configureStore } from "@reduxjs/toolkit";

import ThemeReducers from "./Reducers/ThemeReducers";
import AuthReducers from "./Reducers/AuthReducers";
import VanueReducers from "./Reducers/VanueReducers";
import SpaceReducers from "./Reducers/SpaceReducers";
import bookingReducer from "./Reducers/BookingsReducer";
import MessagesReducer from "./Reducers/MessagesReducer";

import agentReducer from "./Slice/agentSlice";

import { agentApi } from "./Slice/agentApi";

export const store = configureStore({
  reducer: {
    theme: ThemeReducers,
    venues: VanueReducers,
    spaces: SpaceReducers,
    auth: AuthReducers,
    messages: MessagesReducer,
    bookings: bookingReducer,
    agent: agentReducer,
    [agentApi.reducerPath]: agentApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(agentApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
